<template>
	<div>
		<!--loader - message--->
		<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
		<div v-if="congratulation_module && formDisplayVar == ''">
			<div class="middleBox whitebox border radius mb-3">
				<div class="congratulations">
					<div class="logo_congrats">
						<img src="../../../../static/fxView/images/check.svg" alt="Congratulations" />
					</div>
					<div class="subtitle">
						<h3>
							{{ $t("rb_congo") }}
							<span class="green">
								{{ get_user.profile.firstname }}
								{{ get_user.profile.lastname }}
							</span>
						</h3>
						<p>
							{{ $t("createzullu_Your") }} {{ platform }}
							{{ $t("demoacc_demomsg") }}
						</p>
						<ul class="includeWdth">
							<li>
								<strong> {{ $t("sub_tradingId") }}</strong>
								{{ account_detail.account_id }}
							</li>
							<li>
								<strong> {{ $t("lg_password") }}</strong>{{ firstChar(account_detail.password) }}
							</li>
							<li>
								<strong> {{ $t("dash_Leverage") }}</strong>
								{{ account_detail.leverage }}
							</li>
							<li>
								<strong> {{ $t("createzullu_accountBaseCurrency") }}</strong>
								{{ account_detail.currency }}
							</li>
						</ul>
					</div>
				</div>
				<div
					class="full-width ButtonTrade submitButton align-items-center justify-content-center d-flex mt-3 w-100">
					<a class="prism_btn btn_sm darkBG mr-3" href="#" @click.prevent="
						congratulation_module = false;
					reset();
					">{{ $t("step5_back") }}</a>
					<a class="prism_btn btn_sm"
						href="http://demo.actforex.sysfx.com:8100/trade/actlite.jsp?entry=demo.245" target="_blank"
						v-if="platform == 'ACT'">
						{{ $t("createzullu_tradenow") }}</a>
					<router-link class="prism_btn btn_sm"
						:to="{ path: $env_var.downloadPlatformLink1.MT4.webTraderInternalLink, query: { 'platform': 'MT4', 'id': account_detail.account_id } }"
						target="_blank" v-else-if="platform.toUpperCase() == 'MT4'">{{ $t("createzullu_tradenow")
						}}</router-link>
					<a class="prism_btn btn_sm" title="web_trader"
						:href="`${$env_var.downloadPlatformLink1.MT5.webdemoAccount}${account_detail.account_id}&server=FXView-Demo`"
						target="_blank" v-else>
						{{ $t("createzullu_tradenow") }}
					</a>
				</div>
			</div>
			<div class="middleBox whitebox border radius mb-5">
				<div class="text-center innerTitle pb-3 mb-3">
					<h2 class="mb-3">{{ $t("dp_download") }} {{ platform }}</h2>
				</div>
				<div class="downloadPlatform d-flex align-items-center">
					<div class="dpBox d-flex align-items-center">
						<a :href="$env_var.downloadPlatformLink1[platform.toUpperCase()].window" target="_blank">
							<div class="ico">
								<img src="../../../../static/fxView/images/windows.svg" alt="" />
							</div>
							<div class="desc">
								<p>{{ $t("forWindows") }}</p>
							</div>
						</a>
					</div>
					<div class="dpBox d-flex align-items-center">
						<a :href="$env_var.downloadPlatformLink1[platform.toUpperCase()].ios" target="_blank">
							<div class="ico">
								<img src="../../../../static/fxView/images/ios.svg" alt="" />
							</div>
							<div class="desc">
								<p>{{ $t("forIos") }}</p>
							</div>
						</a>
					</div>
					<div v-if="platform != 'ACT'" class="dpBox d-flex align-items-center">
						<a :href="$env_var.downloadPlatformLink1[platform.toUpperCase()].mac" target="_blank">
							<div class="ico">
								<img src="../../../../static/fxView/images/mac_ico.svg" alt="" />
							</div>
							<div class="desc">
								<p>{{ $t("dp_forMAC") }}</p>
							</div>
						</a>
					</div>
					<div class="dpBox d-flex align-items-center">
						<a :href="$env_var.downloadPlatformLink1[platform.toUpperCase()].actDemo" target="_blank" v-if="platform == 'ACT'">
							<div class="ico">
								<img src="../../../../static/fxView/images/android.svg" alt="" />
							</div>
							<div class="desc">
								<p>{{ $t("WEB") }}</p>
							</div>
						</a>
						<router-link
							:to="{ path: $env_var.downloadPlatformLink1.MT4.webTraderInternalLink, query: { 'platform': 'MT4', 'id': account_detail.account_id } }"
							target="_blank" v-else-if="platform.toUpperCase() == 'MT4'">
							<div class="ico">
								<img src="../../../../static/fxView/images/webtrader.svg" alt="" />
							</div>
							<div class="desc">
								<p>{{ $t("WEB") }}</p>
							</div>
						</router-link>
						<a title="web_trader"
							:href="`${$env_var.downloadPlatformLink1.MT5.webdemoAccount}${account_detail.account_id}&server=FXView-Demo`"
							target="_blank" v-else>
							<div class="ico">
								<img src="../../../../static/fxView/images/webtrader.svg" alt="" />
							</div>
							<div class="desc">
								<p>{{ $t("WEB") }}</p>
							</div>
						</a>
					</div>
				</div>
			</div>
		</div>
		<div class="row justify-content-center align-items-center no-gutters" v-else-if="!congratulation_module || parseInt(formDisplayVar) == 2">
			<div class="stepForm" v-if="get_user.profile.firstname == '' || get_user.profile.firstname == null || get_user.mobile_no == '' || get_user.mobile_no == null">
				<div class="mainTitle text-center mt-4 mb-3">
					<h3 class="mb-4">{{ $t("personalInfo") }}</h3>
					<message-component :message="response_msg" :messageType="msg_type"
						v-if="response_msg != ''"></message-component>
				</div>
				<div class="CustomBlockWidth inMiddle-area radius whitebox p-4">
					<div class="form-group field-wrapper" v-if="get_user.profile.firstname == '' || get_user.profile.firstname == null">
						<input placeholder=" " type="text" v-model="f_name" v-validate="'required'" name="f_name"
							class="float-field form-control" :class="{
								'is-invalid': personalInfoSubmitted && errors.has('f_name'),
							}" ref="f_nameInput" />
						<label for="password" class="float-label">{{ $t("fname") }}</label>
						<ul>
							<li v-for="error in errors.collect('f_name')">{{ error }}</li>
						</ul>
					</div>
					<div class="form-group field-wrapper" v-if="get_user.profile.lastname == '' || get_user.profile.lastname == null">
						<input placeholder=" " type="text" v-model="l_name" class="float-field form-control"
							v-validate="'required'" name="l_name" :class="{
								'is-invalid': personalInfoSubmitted && errors.has('l_name'),
							}" ref="l_nameInput" />
						<label for="password" class="float-label">{{ $t("lname") }}</label>
						<ul>
							<li v-for="error in errors.collect('l_name')">{{ error }}</li>
						</ul>
					</div>
					<div class="form-group field-wrapper" v-if="get_user.mobile_no == '' || get_user.mobile_no == null">
						<vue-phone-number-input v-model="mobile_no" :no-example="true"
							:default-country-code="get_user.profile.country"
							v-validate="{ required: true, min: 5, max: 15 }" ref="mobile_noInput"
							:class="{ 'is-invalid': submitted && errors.has('mobile_no') }" name="mobile_no"
							@update="updatedText" />
						<ul>
							<li v-for="error in errors.collect('mobile_no')">{{ error }}</li>
						</ul>
						<p class="error" v-if="!numberValid">{{ $t("InvalidNumber") }}</p>
					</div>
					<div class="text-center">
						<button class="prism_btn btn_sm" v-on:click.prevent="submitPersonalInfo()">
							{{ $t("saveContinue") }}
						</button>
					</div>
				</div>
			</div>
			<div class="col-12 col-md-12" v-else>
				<div id="messageBlock" class="stepForm">
					<div class="mainTitle text-center mt-4 mb-3">
						<h2 class="mb-3">
							{{ $t("createzullu_open") }}
							<span v-html="parseInt(demo_live_select) == 0 ? 'Demo' : 'Live'"></span>
							{{ $t("createzullu_tradingAcc") }}
						</h2>
						<message-component :message="response_msg" :messageType="msg_type"
							v-if="response_msg != ''"></message-component>
					</div>
					<div class="middleBox inMiddle-area radius whitebox p-4">
						<div class="row">
							<!-- Platforms -->
							<div class="col-12" v-if="parseInt(get_user.pro_user) == 0">
								<h4 class="mb-3">{{$t('fxPlatform')}}</h4>
							</div>
							<div class="col-12 col-md-4" v-if="parseInt(get_user.pro_user) == 0">
								<div class="customFm border">
									<label class="customRadio-button m-0">
										<p v-html="$t('welcm_actTrader')"></p>
										<input type="radio" name="platform" value="ACT" v-model="platform"
											v-validate="'required'" class="float-field form-control" :class="{
												'is-invalid': submitted && errors.has('platform'),
											}" ref="platformInput" @focus="trackEvent('Platform')" />
										<span class="checkmark"></span>
									</label>
								</div>
							</div>
							<!-- <div class="col-12 col-md-4" v-if="parseInt(get_user.pro_user) == 0">
								<div class="customFm border">
									<label class="customRadio-button m-0">
										{{ $t("demoacc_MT4") }}
										<input type="radio" name="platform" value="MT4" v-model="platform" v-validate="'required'"
										class="float-field form-control" :class="{
											'is-invalid': submitted && errors.has('platform'),
										}" ref="platformInput" @focus="trackEvent('Platform')" />
										<span class="checkmark"></span>
									</label>
								</div>
							</div> -->
							<div class="col-12 col-md-4" v-if="parseInt(get_user.pro_user) == 0">
								<div class="customFm border">
									<label class="customRadio-button m-0">{{ $t("demoacc_MT5") }}
										<input type="radio" name="platform" value="MT5" v-model="platform"
											v-validate="'required'" class="float-field form-control" :class="{
												'is-invalid': submitted && errors.has('platform'),
											}" ref="platformInput" @focus="trackEvent('Platform')" />
										<span class="checkmark"></span>
									</label>
								</div>
							</div>
							<div class="col-12 my-3">
								<ul>
									<li class="error">{{ errors.first("platform") }}</li>
								</ul>
							</div>
							<!-- Accounts  -->
							<div class="col-12">
								<h4 class="mb-3">{{$t('fxAccount')}}</h4>
							</div>
							<div class="col-12 col-md-6 mb-4" v-if="parseInt(get_user.pro_user) == 0"> 
								<div class="customFm border">
									<label class="customRadio-button m-0">
										<p>{{ $t('fxRawECN') }}</p>
										<input type="radio" name="account_type" value="REC" v-model="account_type"
											v-validate="'required'" class="float-field form-control" :class="{
												'is-invalid': submitted && errors.has('account_type'),
											}" ref="account_typeInput" @focus="trackEvent('Account')" />
										<span class="checkmark"></span>
									</label>
								</div>
							</div>
							<div class="col-12 col-md-6 mb-4" v-if="parseInt(get_user.pro_user) == 1">
								<div class="customFm border">
									<label class="customRadio-button m-0">
										<p>{{ $t('fxRawECN') }}</p>
										<input type="radio" name="account_type" value="RISL" v-model="account_type"
											v-validate="'required'" class="float-field form-control" :class="{
												'is-invalid': submitted && errors.has('account_type'),
											}" ref="account_typeInput" @focus="trackEvent('Account')" />
										<span class="checkmark"></span>
									</label>
								</div>
							</div>
					
							<div class="col-12 col-md-6 mb-4" v-if="parseInt(get_user.pro_user) == 0">
								<div class="customFm border">
									<label class="customRadio-button m-0">
										<p>{{ $t('fxZeroCommission') }}</p>
										<input type="radio" name="account_type" value="STD" v-model="account_type"
											v-validate="'required'" class="float-field form-control" :class="{
												'is-invalid': submitted && errors.has('account_type'),
											}" ref="account_typeInput" @focus="trackEvent('Account')" />
										<span class="checkmark"></span>
									</label>
								</div>
							</div>
							<div class="col-12 col-md-6 mb-4" v-if="parseInt(get_user.pro_user) == 1">
								<div class="customFm border">
									<label class="customRadio-button m-0">
										<p>{{ $t('fxZeroCommission') }}</p>
										<input type="radio" name="account_type" value="SISL" v-model="account_type"
											v-validate="'required'" class="float-field form-control" :class="{
												'is-invalid': submitted && errors.has('account_type'),
											}" ref="account_typeInput" @focus="trackEvent('Account')" />
										<span class="checkmark"></span>
									</label>
								</div>
							</div>
							<div class="col-12 col-md-6 mb-4" v-if="parseInt(get_user.pro_user) == 0"> 
								<div class="customFm border">
									<label class="customRadio-button m-0">
										<p>{{$t('fxPremiumECN')}}</p>
										<input type="radio" name="account_type" value="ECN" v-model="account_type"
											v-validate="'required'" class="float-field form-control" :class="{
												'is-invalid': submitted && errors.has('account_type'),
											}" ref="account_typeInput" @focus="trackEvent('Account')" />
										<span class="checkmark"></span>
									</label>
								</div>
							</div>
							<div class="col-12 col-md-6 mb-4" v-if="parseInt(get_user.pro_user) == 1">
								<div class="customFm border">
									<label class="customRadio-button m-0">
										<p>{{$t('fxPremiumECN')}}</p>
										<input type="radio" name="account_type" value="EISL" v-model="account_type"
											v-validate="'required'" class="float-field form-control" :class="{
												'is-invalid': submitted && errors.has('account_type'),
											}" ref="account_typeInput" @focus="trackEvent('Account')" />
										<span class="checkmark"></span>
									</label>
								</div>
							</div>
							<!-- <div class="col-12 col-md-6 mb-4"
								v-if="parseInt(get_user.pro_user) == 0 && platform != 'ACT' && get_user.classic">
								<div class="customFm border">
									<label class="customRadio-button m-0">
										<p>Classic</p>
										<input type="radio" name="account_type" value="CLA" v-model="account_type"
											v-validate="'required'" class="float-field form-control" :class="{
												'is-invalid': submitted && errors.has('account_type'),
											}" ref="account_typeInput" @change="resetData" />
										<span class="checkmark"></span>
									</label>
								</div>
							</div> -->
							<div class="col-12 my-1">
								<ul>
									<li class="error">{{ errors.first("account_type") }}</li>
								</ul>
							</div>
							<div class="col-12 mb-3" v-if="account_type == 'CLA'">
								<div class="slctcurrency">
									<h4 class="mb-3">{{ $t("dash_currency") }}</h4>
									<input type="hidden" v-model="select_currency" v-validate="'required'"
										class="float-field form-control"
										:class="{ 'is-invalid': submitted && errors.has('select_currency') }"
										ref="select_currencyInput" name="select_currency" />
									<ul>
										<li v-for="currency in get_user.classic_currency"
											:class="select_currency == currency ? 'selected' : ''"
											@click.prevent="select_currency = currency">
											<img :src="`../../../../static/fxView/images/${currency.toLowerCase()}.svg`"
												:alt="currency" />
											{{ currency }}
										</li>
									</ul>
								</div>
								<p v-if="errors.first('select_currency')">
									<span class="error">{{ $t('fxCurrencyErr') }}</span>
								</p>
							</div>
							<div v-else>
								<div class="col-12 mb-3" v-if="parseInt(get_user.pro_user) == 1">
									<div class="slctcurrency">
										<h4 class="mb-3">{{ $t("dash_currency") }}</h4>
										<input type="hidden" v-model="select_currency" v-validate="'required'"
											class="float-field form-control"
											:class="{ 'is-invalid': submitted && errors.has('select_currency') }"
											ref="select_currencyInput" name="select_currency" />
										<ul>
											<li :class="select_currency == 'USD' ? 'selected' : ''"
												@click.prevent="select_currency = 'USD'">
												<img src="../../../../static/fxView/images/usd.svg" alt="usd" />
												{{ $t("createzullu_USD") }}
											</li>
										</ul>
									</div>
									<p v-if="errors.first('select_currency')">
										<span class="error">{{ $t('fxCurrencyErr') }}</span>
									</p>
								</div>
								<div class="col-12 mb-3" v-if="parseInt(get_user.pro_user) == 0">
									<div class="slctcurrency">
										<h4 class="mb-3">{{ $t("dash_currency") }}</h4>
										<input type="hidden" v-model="select_currency" v-validate="'required'"
											class="float-field form-control"
											:class="{ 'is-invalid': submitted && errors.has('select_currency') }"
											ref="select_currencyInput" name="select_currency" />
										<ul>
											<li :class="select_currency == 'USD' ? 'selected' : ''"
												@click.prevent="select_currency = 'USD'">
												<img src="../../../../static/fxView/images/usd.svg" alt="usd" />
												{{ $t("createzullu_USD") }}
											</li>
											<li :class="select_currency == 'EUR' ? 'selected' : ''"
												@click.prevent="select_currency = 'EUR'">
												<img src="../../../../static/fxView/images/eur.svg" alt="eur" />
												{{ $t("createzullu_EUR") }}
											</li>
											<!-- <li :class="select_currency == 'GBP' ? 'selected' : ''" @click.prevent="select_currency = 'GBP'">
												<img src="../../../../static/fxView/images/gbp.svg" alt="gbp" />
												{{ $t("createzullu_GBP") }}
											</li> -->
											<li :class="select_currency == 'AUD' ? 'selected' : ''"
												@click.prevent="select_currency = 'AUD'">
												<img src="../../../../static/fxView/images/aud.svg" alt="aud" />
												{{ $t("createzullu_AUD") }}
											</li>
											<li :class="select_currency == 'ZAR' ? 'selected' : ''"
												@click.prevent="select_currency = 'ZAR'">
												<img src="../../../../static/fxView/images/zar.svg" alt="zar"
													class="rounded-circle" />
												{{ $t("createzullu_ZAR") }}
											</li>
											<li :class="select_currency == 'CAD' ? 'selected' : ''"
												@click.prevent="select_currency = 'CAD'">
												<img src="../../../../static/fxView/images/cad.svg" alt="aud" />
												{{$t('fxCAD')}}
											</li>
										</ul>
									</div>
									<p v-if="errors.first('select_currency')">
										<span class="error">{{$t('fxCurrencyErr')}}</span>
									</p>
								</div>
							</div>
							<div class="col-12 mb-3">
								<input type="hidden" v-model="leverage" v-validate="'required'"
									class="float-field form-control"
									:class="{ 'is-invalid': submitted && errors.has('leverage') }" ref="leverageInput"
									name="leverage" @focus="trackEvent('Leverage')" />
								<div class="slctcurrency">
									<h4 class="mb-3">{{ $t("Dlist_leverage") }}</h4>
									<ul>
										<li :class="leverageDisabledFunc(key)" @click.prevent="leverageSelectFuns(key)"
											v-html="key + 'X'" v-for="(list, key) in $env_var.leverageJson"></li>
									</ul>
									<p v-if="errors.first('leverage')">
										<span class="error">{{
											$t("createzullu_leverageField")
										}}</span>
									</p>
								</div>
							</div>
							<div class="col-12 col-md-12 border-top pt-3">
								<div class="acPassword">
									<h3 class="mb-3">{{ $t("lg_password") }}</h3>
								</div>
								<div class="row mt-3">
									<div class="col-12 col-md-6">
										<div class="form-group field-wrapper">
											<div class="mb-3">
												<input :type="inputtype" placeholder=" " v-model="password"
													class="float-field form-control"
													v-validate="{ required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^*/])\S{8,15}$/, }"
													name="password"
													:class="{ 'is-invalid': submitted && errors.has('password'), }"
													ref="passwordInput" @keyup="testing()" v-if="platform == 'MT5'"
													@focus="trackEvent('Password')" />
												<input :type="inputtype" placeholder=" " v-model="password"
													class="float-field form-control"
													v-validate="{ required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^*/])\S{6,15}$/, }"
													name="password"
													:class="{ 'is-invalid': submitted && errors.has('password'), }"
													ref="passwordInput" @focus="trackEvent('Password')"
													@keyup="testing()" v-else />
												<label for="password" class="float-label">
													{{ $t("createzullu_accountPassword") }}
												</label>
												<feather :type="iconType" class="toggle-password"
													@click.prevent="switchVisibility('1')">
												</feather>
											</div>
											<p class="error" v-for="error in errors.collect('password')"
												v-if="!submitError">
												<span v-if="error == 'The password field is required.'">{{$t("reg_passwordFieldReq") }}</span>
												<span v-else-if="error == 'The password field format is invalid.'">
													<span v-if="platform == 'MT5'">{{ $t("cp_passCharval").replace('6','8') }}</span>
													<span v-else>{{ $t("cp_passCharval") }}</span>
												</span>
											</p>
											<p class="error" v-if="submitError">
												<span>{{ $t("demoacc_passwordMust") }}</span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 col-md-12 mt-3">
								<div
									class="full-width submitButton justify-content-center align-items-center d-flex mt-3 w-100">
									<button class="prism_btn btn_sm" v-on:click.prevent="submit()">
										{{ $t("createzullu_createAccount") }}
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { fxViewMixins } from "@/plugins/fxView";
import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls';
import * as types from "@/types";
import { mapActions } from "vuex";
export default {
	name: "CREATE-ACCOUNT",
	mixins: [fxViewMixins],
	data() {
		return {
			mszValidation: "",
			submitError: false,
			pageLoader: false,
			response_msg: "",
			msg_type: "",
			userCountry: "IN",
			select_currency: "",
			account_type: "",
			platform: "ACT",
			leverage: "500",
			password: "",
			confirmPassword: "",
			error_msg_password: "",
			submitted: false,
			congratulation_module: false,
			account_detail: {},
			inputtype: "password",
			showpassword: false,
			iconType: "eye-off",
			inputtype1: "password",
			showpassword1: false,
			iconType1: "eye-off",
			numberValid: true,
			demo_live_select: "0",
			numberWithCountry: "",
			platformJson: {
				MT5: {
					window:
						"https://download.mql5.com/cdn/web/fxview.uk.ltd/mt5/fxview5setup.exe?utm_campaign=download.platform&utm_source=global.fxview.com&master_site_id=gyjkxtugcevrzsvxpyrlyetvsbupyvosri",
					ios: "https://download.mql5.com/cdn/mobile/mt5/ios?utm_campaign=download.platform&utm_source=global.fxview.com&master_site_id=gyjkxtugcevrzsvxpyrlyetvsbupyvosri&server=FXView-Demo,FXView-Live,FXView2-Demo,FXView2-Live",
					android:
						"https://play.google.com/store/apps/details?id=net.metaquotes.metatrader5",
					web: { path: '/web-trade-link', query: { 'platform': 'MT5' } },
				},
				MT4: {
					window:
						"https://download.mql5.com/cdn/web/fxview.uk.ltd/mt4/fxview4setup.exe",
					ios: "https://apps.apple.com/us/app/metatrader-4/id496212596",
					android:
						"https://play.google.com/store/apps/details?id=net.metaquotes.metatrader4",
					web: { path: '/new-web-trade-link', query: { 'platform': 'MT4' } },
				},
				ACT: {
					window: "http://setup.sysfx.com/setup/trader/fxview/trader_setup.exe",
					ios: "https://www.apple.com/ios/app-store/",
					android:
						"https://play.google.com/store/apps/details?id=fxview.trader",
					web: "http://demo.actforex.sysfx.com:8100/trade/actlite.jsp?entry=demo.245",
				},
			},

			f_name: "",
			m_name: "",
			l_name: "",
			mobile_no: "",
			mobileShowvar: false,
			show_mob: true,
			personalInfoSubmitted: false,
		};
	},
	computed: {
		OnlyUsers() {
			// console.log(this.get_user.profile.user_id);
			return [12832, 1173, 59692].includes(this.get_user.profile.user_id);
		},
	},
	methods: {
		...mapActions({
			_runSaveUserName: types.RUN_SAVE_USER_NAME,
		}),
		resetData() {
			this.select_currency = "";
		},
		errorScroll() {
			console.log(this.formDisplayVar);
			document
				.getElementById("messageBlock")
				.scrollIntoView({ behavior: "smooth" });
		},
		submitPersonalInfo() {
			const _that = this;
			_that.personalInfoSubmitted = true;
			_that.$validator.validate().then((valid) => {
				if (valid) {
					let inputJson = {
						globalParams: {
							fname: _that.f_name,
							mname: _that.m_name,
							lname: _that.l_name,
							mobile_no: _that.numberWithCountry,
						},
						localParams: { parameter: _that },
					};
					_that._runSaveUserName(inputJson);
				} else {
					_that.handleValidationErrorAdvanced(_that.errors);
				}
			});
		},
		reset() {
			this.password = "";
			this.confirmPassword = "";
			this.leverage = "";
			this.select_currency = "";
			this.account_type = "";
			this.platform = "";
		},
		conversionOfAmount(currency, amount) {
			let conversion_json = {
				globalParams: {
					amount: amount,
					from: currency,
					to: "USD",
				},
				localParams: {
					parameter: this,
					from: 'create-account'
				},
			};
			this._runBitcoinConversion(conversion_json);
		},
		testing() {
			var specialArray = [
				"!",
				"@",
				"#",
				"$",
				"%",
				"^",
				"&",
				"*",
				"(",
				")",
				"_",
				"-",
				"+",
				"=",
				"[",
				"]",
				"{",
				"}",
				";",
				":",
				'"',
				"/",
				"?",
				".",
				">",
				"<",
				"|",
				"/",
				"*",
				",",
			];
			var specialArrayAccept = ["!", "@", "#", "$", "%", "^", "*", "/"];
			let truVar = "";

			for (let i = 0; i <= this.password.length - 1; i++) {
				if (specialArray.indexOf(this.password[i]) > 0) {
					if (specialArrayAccept.indexOf(this.password[i]) == -1) {
						truVar = "1";
					}
				}

				if (i == this.password.length - 1) {
					if (truVar == "1") {
						this.submitError = true;
					} else {
						this.submitError = false;
					}
				}
			}
		},
		leverageDisabledFunc(getKey) {
			if (parseInt(this.leverage) == parseInt(getKey)) {
				return "selected";
			} else {
				return "";
			}
		},
		updatedText(e) {
			this.numberWithCountry = e.formattedNumber;
			this.numberValid = e.isValid;
		},
		firstChar(getPassword) {
			let first = getPassword.charAt(0);
			let last = getPassword.charAt(getPassword.length - 1);
			return first + "*****" + last;
		},
		switchVisibility(getData) {
			if (getData == "1") {
				this.showpassword = !this.showpassword;
				if (this.showpassword) {
					this.inputtype = "text";
					this.iconType = "eye";
				} else {
					this.inputtype = "password";
					this.iconType = "eye-off";
				}
			} else {
				this.showpassword1 = !this.showpassword1;
				if (this.showpassword1) {
					this.inputtype1 = "text";
					this.iconType1 = "eye";
				} else {
					this.inputtype1 = "password";
					this.iconType1 = "eye-off";
				}
			}
		},

		submit() {
			const _that = this;
			_that.submitted = true;

			if (parseInt(this.get_user.pro_user) == 1) {
				// _that.account_type = this.account_type;
				_that.platform = "MT5";
				_that.select_currency = _that.select_currency;
			}

			_that.$validator.validate().then((valid) => {
				if (valid && !_that.submitError) {
					let accountJson = {
						globalParams: {
							currency: _that.select_currency,
							account_type: _that.account_type,
							platform: _that.platform,
							leverage: _that.leverage,
							password: _that.password,
							demo_live: _that.demo_live_select.toString(),
						},
						localParams: { parameter: _that },
					};
					this.$trackEvent('CP+Demo+account+Create+account')
					_that._runCreateAccount(accountJson);
				} else {
					_that.handleValidationErrorAdvanced(_that.errors);
					let list = _that.errors.items.filter(v => v.rule != "required").map(v => v.msg)
					if (list.length) {
						try {
							window.dataLayer.push({
								'event': 'error',
								'errorType': 'create demo tading account error',
								'errorMessage': list.join(',').replace('The password field format is invalid.', this.$t('demoacc_passwordMust'))
							});
						} catch (ex) {
							console.log('ex', ex)
						}
					}
				}
			});
		},
		leverageSelectFuns(getKey) {
			this.$trackEvent('CP+Demo+account+Leverage');
			this.leverage = getKey;
		},
		trackEvent(event) {
			switch (event) {
				case 'Platform':
					this.$trackEvent('CP+Demo+account+Platform')
					break;
				case 'Account':
					this.$trackEvent('CP+Demo+account+Account')
					break;
				case 'Leverage':
					this.$trackEvent('CP+Demo+account+Leverage')
					break;
				case 'Password':
					this.$trackEvent('CP+Demo+account+Password')
					break;
				case 'currency':
					this.$trackEvent('CP+Demo+account+currency')
					break;

			}
		}
	},
	// mounted() {
	//   if(this.$store.getters[Const.GET_DEPOSIT_LIST].records && this.$store.getters[Const.GET_DEPOSIT_LIST].records.length > 0){
	//     let depositAmount = this.$store.getters[Const.GET_DEPOSIT_LIST].records.filter((item) => item.payment_status === "2");
	//     let totalDepositAmount = 0;
	//     for ( let i = 0, length = depositAmount.length; i < length; i++ ) {
	//       totalDepositAmount += parseInt(depositAmount[i].amount);
	//     }
	//     console.log('------------ amount', totalDepositAmount )
	//     return totalDepositAmount
	//   }
	// },
	created() {
		this.$trackEvent('CP+Demo+account+Pageview');
		if (
			this.get_user.profile.firstname != "" &&
			this.get_user.profile.firstname != null
		) {
			this.f_name = this.get_user.profile.firstname;
		}
		if (
			this.get_user.profile.lastname != "" &&
			this.get_user.profile.lastname != null
		) {
			this.l_name = this.get_user.profile.lastname;
		}

		if (this.get_user.mobile_no != "" && this.get_user.mobile_no != null) {
			this.mobile_no = this.get_user.mobile_no;
		} else {
			this.mobileShowvar = true;
		}
	},


};
</script>


// WEBPACK FOOTER //
// src/components/fxView/tradingAccounts/create_account.vue